import { CancelTokenSource } from 'axios';
import axios from 'services/http';
import { PatientHistoryDto } from 'ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/patient-history`;

export const getPatientHistory = (
    patientId: Number, source: CancelTokenSource): Promise<PatientHistoryDto> => {

  return axios
      .get(`${apiUri}/${patientId}`, {cancelToken: source.token})
      .then((response) => response.data);
};
